const AppointmentModal = /* GraphQL */ `
  query AppointmentModal($path: String!, $language: String = "en") {
    item(path: $path, language: $language) {
      ... on Item {
        name
        epicPhysicianID: field(name: "epicPhysicianID") {
          value
        }
        epicDeptID: field(name: "epicDeptID") {
          value
        }
        locationName: field(name: "locationName") {
          value
        }
        providerTitle: field(name: "title") {
          value
        }
      }
    }
  }
`;

export default AppointmentModal;
